import React, { useState } from "react";
import {
  DatePicker,
  TimePicker,
  Select,
  Button,
  Dropdown,
  Space,
  Row,
  Col,
} from "antd";
import { DownOutlined } from "@ant-design/icons";

const FiltersDropdown = ({
  startDate,
  setStartDate,
  startTime,
  setStartTime,
  endDate,
  setEndDate,
  endTime,
  setEndTime,
  locationOptions,
  locationOptionSelected,
  handleLocationChange,
  cameraoptions,
  cameraOptionSelected,
  handleCameraChange,
  alertoptions,
  optionSelected,
  handleAlertChange,
  statusOptionSelected,
  handleStatusChange,
  handleGetData,
  alertsAssignedMailsoptions,
  handleChangeAletsAssignedEmails,
  alertsAssignedMailsSelected,
}) => {
  const [openDropDown, setOpenDropDown] = useState(false);

  const handleOpenDropDown = () => {
    setOpenDropDown(!openDropDown);
  };

  const items = [
    {
      label: (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <DatePicker
                format="DD-MM-YYYY"
                value={startDate}
                onChange={(date) => setStartDate(date)}
                placeholder="Start Date"
                className="w-full"
              />
            </Col>
            <Col span={12}>
              <DatePicker
                format="DD-MM-YYYY"
                value={endDate}
                onChange={(date) => setEndDate(date)}
                placeholder="End Date"
                className="w-full"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <TimePicker
                value={startTime}
                onChange={(time) => setStartTime(time)}
                placeholder="Start Time"
                className="w-full"
                format="HH:mm:ss"
              />
            </Col>
            <Col span={12}>
              <TimePicker
                value={endTime}
                onChange={(time) => setEndTime(time)}
                placeholder="End Time"
                className="w-full"
                format="HH:mm:ss"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                mode="multiple"
                allowClear
                options={locationOptions}
                onChange={handleLocationChange}
                placeholder="Select Locations"
                value={locationOptionSelected}
                className="w-full"
              />
            </Col>
            <Col span={12}>
              <Select
                mode="multiple"
                allowClear
                options={cameraoptions}
                onChange={handleCameraChange}
                placeholder="Select Cameras"
                value={cameraOptionSelected}
                className="w-full"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "2",
    },
    {
      label: (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                mode="multiple"
                allowClear
                options={alertoptions}
                onChange={handleAlertChange}
                placeholder="Select Alerts"
                value={optionSelected}
                className="w-full"
              />
            </Col>
            <Col span={12}>
              <Select
                mode="multiple"
                allowClear
                options={[
                  { label: "Open", value: "Open" },
                  { label: "Close", value: "Close" },
                  { label: "In Progress", value: "InProgress" },
                  { label: "Assigned", value: "Assigned" },
                ]}
                onChange={handleStatusChange}
                placeholder="Select Status"
                value={statusOptionSelected}
                className="w-full"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "3",
    },
    {
      label: (
        <div>
          <Row>
            <Col span={24}>
              <Select
                mode="multiple"
                allowClear
                options={alertsAssignedMailsoptions}
                onChange={handleChangeAletsAssignedEmails}
                placeholder="Select assigned to"
                value={alertsAssignedMailsSelected}
                className="w-full"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "4",
    },
    {
      label: (
        <Button
          type="primary"
          onClick={handleGetData}
          className="w-full bg-teal-600 hover:bg-teal-700"
        >
          Get Data
        </Button>
      ),
      key: "5",
    },
  ];

  return (
    <div className="flex justify-end mb-6">
      <Dropdown
        menu={{ items }}
        trigger={["click"]}
        open={openDropDown}
        overlayClassName="filter-dropdown"
      >
        <Button
          onClick={handleOpenDropDown}
          className="bg-teal-700 hover:bg-teal-600 text-white flex items-center"
        >
          <Space>
            Filters
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
};

export default FiltersDropdown;
